import i18n from "../i18n";
import { Entry } from "../model/entry/Entry";

export function getEntryLabel(entry?: Partial<Entry>): string {
  return (
    entry?.fields?.name ||
    entry?.fields?.email ||
    entry?.fields?.phone ||
    entry?._id ||
    i18n.t("common.entry")
  );
}
